import React, { Component } from 'react';
import {
    Row,
    Button,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Collapse,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { Colxx, Separator } from '../../../components/common/CustomBootstrap';
import Breadcrumb from '../../navs/Breadcrumb';
import IntlMessages from '../../../helpers/IntlMessages';

class ContentComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { messages } = this.props.intl;
        const {
            // heading,
            // pageSizes,
            // selectedPageSize,
            // startIndex,
            // endIndex,
            // match,
            // totalItemCount,
            // changePageSize,
            onSearchKey,
        } = this.props;

        return (
            <Row className='list-page-heading__row'>
                <Colxx xxs='12'>
                    {/* <div className='mb-2 text-center uppercase'>
                        <h1 className='w-100'>
                            <IntlMessages id={heading} />
                        </h1>
                    </div> */}

                    <div style={{ 
                        position: 'fixed', 
                        bottom: '15px', 
                        left: '50%', 
                        transform: 'translateX(-50%)', 
                        width: 'calc(100% - 30px)', 
                        maxWidth: '500px',
                        zIndex: 1000,
                    }}>
                        <input
                            type='text'
                            name='keyword'
                            id='search'
                            style={{ 
                                width: '100%', 
                                padding: '12px 16px', 
                                border: '1px solid #d7d7d7', 
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                fontSize: '16px'
                            }}
                            placeholder={messages['menu.search'] + ' theo số bàn'}
                            onKeyPress={onSearchKey}
                            onChange={onSearchKey}
                        />
                    </div>
                    {/* <Separator /> */}
                </Colxx>
            </Row>
        );
    }
}

export default injectIntl(ContentComponent);
